<script lang="ts">
  import { RICH_TOOLTIP_CLASS, tooltip } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import { escapeHtml } from "@kontextwerk/web-sdk/core/security"
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import type {
    AssignWorkOrderDraft,
    WorkOrderAssignmentRow,
    WorkOrderAssignmentSelection,
  } from "../../../../contract"
  import WorkOrderAsyncSelect from "./_modules/work-order-async-select"
  import { workOrderAssignmentRecommendationText } from "../../../../_shared/_logic/01-assign-work-order-presentation"

  let {
    row,
    draft,
    organizationId,
    disabled = false,
    onSelectionChange,
  }: {
    row: WorkOrderAssignmentRow
    draft: AssignWorkOrderDraft
    organizationId: string
    disabled?: boolean
    onSelectionChange: (
      row: WorkOrderAssignmentRow,
      selection: WorkOrderAssignmentSelection | null,
    ) => void
  } = $props()

  const recommendationText = $derived(workOrderAssignmentRecommendationText(row))
  const workOrderId = $derived(draft.workOrderId ?? "")
  const selectedWorkOrder = $derived<WorkOrderAssignmentSelection | null>(
    draft.selectedWorkOrder ?? null,
  )
  const preferredSelections = $derived(
    (row.preferredCandidates ?? [])
      .map((candidate) => candidate.selection)
      .filter((selection): selection is WorkOrderAssignmentSelection => Boolean(selection)),
  )

  const handleSelectionChange = (selection: WorkOrderAssignmentSelection | null) => {
    onSelectionChange(row, selection)
  }
</script>

<TableFormCell>
  <div class="work-order-select-cell">
    <WorkOrderAsyncSelect
      {organizationId}
      value={workOrderId}
      {selectedWorkOrder}
      {preferredSelections}
      defaultPropertyId={row.propertyId}
      brightBackground={true}
      disabled={disabled || row.disabled || !organizationId}
      onChange={handleSelectionChange}
    />
    <span
      class="work-order-recommendation"
      aria-label={recommendationText}
      use:tooltip={{ content: escapeHtml(recommendationText), className: RICH_TOOLTIP_CLASS }}
    >
      {recommendationText}
    </span>
  </div>
</TableFormCell>

<style lang="less">
  .work-order-select-cell {
    display: grid;
    gap: 0.22rem;
    min-width: 22rem;
  }

  .work-order-recommendation {
    color: var(--text-invers-100);
    display: block;
    font-size: 0.72rem;
    line-height: 1.2;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
